import ThemeOverrideProps from 'ThemeOverrideProps';
import {StyleSheet} from 'react-native';

const {fontExtraBold, fontBold, fontRegular} = ThemeOverrideProps.sheetStyles;

export const stylesFn = () => {
  return StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    headerContainer: {
      backgroundColor: '#F3EFEB',
    },
    title: {
      paddingTop: 20,
      textAlign: 'center',
      fontSize: 20,
      color: '#070707',
      ...fontExtraBold,
    },
    accentTextContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 8,
    },
    accentText: {
      textAlign: 'center',
      fontSize: 12.5,
      color: '#C90184',
      marginLeft: 8,
      ...fontBold,
    },
    descriptionText: {
      marginTop: 10,
      textAlign: 'center',
      fontSize: 13,
      color: '#070707',
      ...fontRegular,
      marginHorizontal: -20,
    },
    ctaButtonContainer: {
      marginTop: 20,
      marginBottom: 20,
    },
    subDescriptionTextTitle: {
      marginTop: 20,
      textAlign: 'center',
      fontSize: 13,
      color: '#070707',
      ...fontBold,
    },
    subDescriptionText: {
      textAlign: 'center',
      fontSize: 13,
      color: '#070707',
      ...fontRegular,
    },
    bankLogos: {
      width: 257,
      height: 46,
      marginTop: 25,
      marginBottom: 5,
      alignSelf: 'center',
    },
  });
};
